module.exports = __webpack_public_path__ + "img/green-icon-en(3).1c8451ca.png";